import { baseApi } from 'api';

const postApiSlice = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPosts: builder.query({
      query: () => '/post',
      providesTags: ['Posts'],
    }),

    getCategories: builder.query({
      query: () => '/post/category',
      providesTags: ['Categories'],
    }),

    createCategory: builder.mutation({
      query: (category) => ({
        url: '/post/category',
        method: 'POST',
        body: category,
      }),
      invalidatesTags: ['Categories'],
    }),

    updateCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/post/category/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Categories'],
    }),

    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/post/category/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Categories'],
    }),

    getPost: builder.query({
      query: (id) => `/post/${id}`,
      providesTags: ['Posts'],
    }),

    createPost: builder.mutation({
      query: (post) => ({
        url: '/post',
        method: 'POST',
        body: post,
      }),
      invalidatesTags: ['Posts'],
    }),

    updatePost: builder.mutation({
      query: ({ id, data }) => ({
        url: `/post/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Posts'],
    }),

    deletePost: builder.mutation({
      query: (id) => ({
        url: `/post/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Posts'],
    }),
  }),
});

export const {
  useGetPostsQuery,
  useGetPostQuery,
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useCreatePostMutation,
  useUpdatePostMutation,
  useDeletePostMutation,
} = postApiSlice;
